import { Button, Icon, Typography } from '@smartgift/frontend-toolkit';
import { maxBy, minBy } from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AppLoader } from '@hero/atoms';
import { FeeBreakdownInfoModal } from '@hero/components/modals';
import { useCreatePriceLabel } from '@hero/hooks';
import { ShoppingCart } from '@hero/organisms';
import { formatCurrency, getFormattedPrice } from '@hero/utils';

function WidgetFooter({ products, selectedSkus, isLoading, onNextButtonClick }) {
  const { t } = useTranslation();
  const [isFeeBreakdownModalOpen, setIsFeeBreakdownModalOpen] = React.useState(false);

  const { isCAActMustBeApplied } = useCreatePriceLabel({});

  const maxPrice = isCAActMustBeApplied
    ? maxBy(selectedSkus, 'priceBreakdown.display')?.priceBreakdown?.display
    : maxBy(selectedSkus, 'price')?.price;
  const minPrice = isCAActMustBeApplied
    ? minBy(selectedSkus, 'priceBreakdown.display')?.priceBreakdown?.display
    : minBy(selectedSkus, 'price')?.price;

  return (
    <>
      <ShoppingCart.S.WidgetFooterSubtotal>
        <Typography variant="body2">
          {t('priceRange')}:
          <Typography variant="body1Bold" as="span">
            {products?.length > 0
              ? getFormattedPrice({ min: minPrice, max: maxPrice })
              : formatCurrency(0)}
          </Typography>
        </Typography>
        {isCAActMustBeApplied && (
          <ShoppingCart.S.WidgetFooterFeeBreakdownModalButton
            variant="link"
            onClick={() => setIsFeeBreakdownModalOpen(true)}
          >
            {t('feeBreakdownModalOpenButtonText')}
          </ShoppingCart.S.WidgetFooterFeeBreakdownModalButton>
        )}
      </ShoppingCart.S.WidgetFooterSubtotal>
      <ShoppingCart.S.FooterActionButtons>
        <Button endIcon={<Icon name="next" />} onClick={onNextButtonClick} block>
          {t('next')}
        </Button>
      </ShoppingCart.S.FooterActionButtons>
      {isLoading && <AppLoader />}
      {isFeeBreakdownModalOpen && (
        <FeeBreakdownInfoModal
          isOpen={isFeeBreakdownModalOpen}
          onRequestClose={() => setIsFeeBreakdownModalOpen(false)}
        />
      )}
    </>
  );
}

export { WidgetFooter };
